import { render, staticRenderFns } from "./NewChatHistoryPanel.vue?vue&type=template&id=2619ce98"
import script from "./NewChatHistoryPanel.vue?vue&type=script&lang=js"
export * from "./NewChatHistoryPanel.vue?vue&type=script&lang=js"
import style0 from "./NewChatHistoryPanel.vue?vue&type=style&index=0&id=2619ce98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports